import { Trans as TransWithId } from '@lingui/react'

export type MessageDescriptor = {
  id: string
  comment?: string
  message?: string
  values?: Record<string, unknown>
}

export const translateWhenIsId = (msg: string | MessageDescriptor) => {
  if (typeof msg === 'string') return msg

  return <TransWithId id={msg.id} />
}
